var render, staticRenderFns
import script from "./scrollView.vue?vue&type=script&lang=js"
export * from "./scrollView.vue?vue&type=script&lang=js"
import style0 from "./scrollView.vue?vue&type=style&index=0&id=4b880d42&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports